import { render, staticRenderFns } from "./Borealia.vue?vue&type=template&id=73143fd8&scoped=true"
import script from "./Borealia.vue?vue&type=script&lang=js"
export * from "./Borealia.vue?vue&type=script&lang=js"
import style0 from "./Borealia.vue?vue&type=style&index=0&id=73143fd8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73143fd8",
  null
  
)

export default component.exports